import { ActionTree, Commit } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { MyUploadedDocumentState } from './state'
import { MyUploadedDocument } from '@/app/my-uploaded-documents/entities/my-uploaded-document.entity'

export const actions: ActionTree<MyUploadedDocumentState, RootState> = {
    updateDocuments({ commit }: { commit: Commit }, documents: MyUploadedDocument[]) {
        commit('updateDocuments', documents)
    }
}


